import { memo, useRef, useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

import { useAppContext } from "../../../context/appContext";

function LandingPageVideo() {
  const theme = useTheme();
  const { isMobile } = useAppContext();

  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const handlePlay = async () => {
    try {
      await videoRef.current?.play();
      setPlaying(true);
    } catch (err) {
      console.error("Video play failed:", err);
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        px: isMobile ? 2 : 30,
        mt: isMobile ? -4 : -8,
        mb: isMobile ? 4 : 12,
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 1100,
          backgroundColor: theme.palette.background.paper,
          borderRadius: 3,
          overflow: "hidden",
          boxShadow: "0px 4px 16px rgba(0,0,0,0.2)",
        }}
      >
        <Typography
          variant={isMobile ? "h5" : "h3"}
          align="center"
          sx={{
            fontWeight: 700,
            mb: 1,
            mt: 2,
          }}
        >
          Lernvideo
        </Typography>

        <Typography
          variant={isMobile ? "body2" : "body1"}
          align="center"
          sx={{
            mb: 3,
            opacity: 0.8,
            maxWidth: 700,
            mx: "auto",
            px: 2,
          }}
        >
          Wie registrieren? Wie die BSZ-App nutzen? Lerne die Plattform in
          diesem Video etwas kennen.
        </Typography>

        <Box
          sx={{
            position: "relative",
            width: "100%",
            paddingTop: "5%",
            paddingBottom: "5%",
            borderRadius: 2,
            overflow: "hidden",
            backgroundColor: "#000",
          }}
        >
          <video
            ref={videoRef}
            controls
            preload="metadata"
            onPlay={() => setPlaying(true)}
            onPause={() => setPlaying(false)}
            style={{
              width: "100%",
              display: "block",
            }}
          >
            <source src="./static/video/Anleitung KSB-IT.mp4" />
          </video>

          {!playing && (
            <Box
              onClick={handlePlay}
              sx={{
                position: "absolute",
                inset: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                backgroundColor: "rgba(0,0,0,0.15)",
              }}
            >
              <IconButton
                sx={{
                  width: isMobile ? 80 : 120,
                  height: isMobile ? 80 : 120,
                  backgroundColor: "rgba(255,255,255,0.9)",
                  boxShadow: "0px 4px 16px rgba(0,0,0,0.3)",
                  transition: "all 0.2s ease",

                  "&:hover": {
                    backgroundColor: "#ffffff",
                    transform: "scale(1.08)",
                  },
                }}
              >
                <PlayArrowIcon
                  sx={{
                    fontSize: isMobile ? 50 : 80,
                    color: theme.palette.primary.main,
                  }}
                />
              </IconButton>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default memo(LandingPageVideo);
